export default function init() {
  const data = Object.create(null);
  return async (key, dataProvider) => {
    let value = data[key];
    if (!value) {
      value = await dataProvider();
      data[key] = value;
    }
    return value;
  };
}
